import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfDialogYoutube from '@elem/ui/ef-dialog-youtube';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EcoLink from 'eco-design/base/eco-link';
import EfImg from 'elem/ui/ef-img';
import { FC, useMemo, useState } from 'react';
import css from './index.module.scss';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';

const EmailIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
        <rect x="3.00391" y="11.0039" width="26.6667" height="17.3333" rx="1.33333" fill="#5377EA" />
        <rect x="4.33789" y="4.3374" width="24" height="16" rx="1.33333" fill="#EAEFFC" />
        <g filter="url(#filter0_d_702_9169)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.74232 27.3978C3.3036 27.1795 3.00216 26.7266 3.00216 26.2034L3.00216 12.3374L3.50852 12.3374L13.4254 19.5637C13.754 19.8032 13.754 20.1024 13.4254 20.3418L3.74232 27.3978Z"
                fill="url(#paint0_linear_702_9169)"
            />
        </g>
        <g filter="url(#filter1_d_702_9169)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.9335 27.3978C29.3722 27.1795 29.6736 26.7266 29.6736 26.2034L29.6736 12.3374L29.1673 12.3374L19.2504 19.5637C18.9218 19.8032 18.9218 20.1024 19.2504 20.3418L28.9335 27.3978Z"
                fill="url(#paint1_linear_702_9169)"
            />
        </g>
        <g filter="url(#filter2_d_702_9169)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.6706 25.6598V27.0041C29.6706 27.7405 29.0736 28.3374 28.3372 28.3374H4.33724C3.60086 28.3374 3.00391 27.7405 3.00391 27.0041V25.6927L15.6783 18.0828C16.1007 17.8292 16.6286 17.8292 17.051 18.0828L29.6706 25.6598Z"
                fill="url(#paint2_linear_702_9169)"
            />
        </g>
        <line x1="9.66992" y1="9.00423" x2="23.0033" y2="9.00423" stroke="#C6CFE7" strokeWidth="1.33333" />
        <line x1="9.66992" y1="13.0037" x2="23.0033" y2="13.0037" stroke="#C6CFE7" strokeWidth="1.33333" />
        <defs>
            <filter
                id="filter0_d_702_9169"
                x="1.93529"
                y="9.9374"
                width="12.8033"
                height="17.4605"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="-1.33333" />
                <feGaussianBlur stdDeviation="0.533333" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_702_9169" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_702_9169" result="shape" />
            </filter>
            <filter
                id="filter1_d_702_9169"
                x="17.9372"
                y="9.9374"
                width="12.8033"
                height="17.4605"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="-1.33333" />
                <feGaussianBlur stdDeviation="0.533333" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_702_9169" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_702_9169" result="shape" />
            </filter>
            <filter
                id="filter2_d_702_9169"
                x="1.67057"
                y="16.5592"
                width="29.3327"
                height="13.1115"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="0.666667" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0969259 0 0 0 0 0.604818 0 0 0 0.4 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_702_9169" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_702_9169" result="shape" />
            </filter>
            <linearGradient id="paint0_linear_702_9169" x1="16.6099" y1="19.8612" x2="3.00168" y2="19.8612" gradientUnits="userSpaceOnUse">
                <stop stopColor="#96AEFF" />
                <stop offset="0.71219" stopColor="#5C7BE9" />
                <stop offset="1" stopColor="#526DDC" />
            </linearGradient>
            <linearGradient id="paint1_linear_702_9169" x1="16.0659" y1="19.8612" x2="29.6741" y2="19.8612" gradientUnits="userSpaceOnUse">
                <stop stopColor="#96AEFF" />
                <stop offset="0.71219" stopColor="#5C7BE9" />
                <stop offset="1" stopColor="#526DDC" />
            </linearGradient>
            <linearGradient id="paint2_linear_702_9169" x1="16.3372" y1="17.8926" x2="16.3372" y2="28.3374" gradientUnits="userSpaceOnUse">
                <stop stopColor="#96AEFF" />
                <stop offset="0.71219" stopColor="#5C7BE9" />
                <stop offset="1" stopColor="#526DDC" />
            </linearGradient>
        </defs>
    </svg>
);

const TheComp: FC = () => {
    const { pageStatus } = useDP3Store();
    const { t } = useLang(pageStatus === 'statusA' ? 'dp3.teaser.Banner' : 'dp3.landing.Banner');
    const [isShow, setIsShow] = useState(false);

    const props = {
        needTerms: true,
        isMulti: true,
        termsHtml: `* I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-au/TermsOfUse.html" target="_blank">Terms of Service</a>.`,
        contactListId: ['1273707010'],
        fields: [
            {
                id: '11571',
                type: 'multiple',
                value: [1],
                overwrite: false,
            },
        ],
        tipsObj: {
            placeholder: t('placeholder'),
            successTips: 'Thank you for subscribing!',
        },
    };

    const handlePlay = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA Pro 3 | The Best Mate of Your Home Power Independence',
            position: t('btn'),
        });
        setIsShow(true);
    };

    const currentImg = useMemo(() => {
        const statusAImg = {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726665770755/kv_au_pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726665806309/kv_au_m.jpg',
        };
        switch (pageStatus) {
            case IPageStatus.statusA:
                return statusAImg;
            case IPageStatus.statusB:
            case IPageStatus.statusC:
                return {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764840017793-wbksl9-compressed-Brandsite%20Homepage%20Banner%20-%20PC-2560%C3%97800.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764840036888-c3ewvy-compressed-Brandsite/Mob.jpg',
                };
            default:
                return statusAImg;
        }
    }, [pageStatus]);

    return (
        <div id="dp3-teaser-AU1" className={`${css.thecomp} dp3-teaser-AU1 GtmModuleData-section`} data-section-id={'dp3-AU1'} data-section-title={t('title')}>
            <div className="banner-img">
                <EfImg {...currentImg} />
            </div>
            <div className={`banner-info${pageStatus !== 'statusA' ? ' landing' : ''}`}>
                {pageStatus === 'statusA' && <p className="label">{t('subTitle')}</p>}
                <p className="title">{t('title')}</p>
                {pageStatus !== 'statusA' && <p className="label">{t('subTitle')}</p>}
                <p className="desc">{t('desc')}</p>
                {pageStatus === 'statusA' ? (
                    <EfEmarsysEmail {...props} />
                ) : (
                    <div className="btn-container">
                        <EcoLink
                            className="btn GtmModuleData-btn-href"
                            href="https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: 'EcoFlow DELTA Pro 3',
                                position: 'Product Preview',
                                display_type: 'none',
                                module_referral: 'none',
                                jump_module: 'none',
                                __btn_id1: `${css.thecomp} .btn`,
                                __btn_id2: 'https://au.ecoflow.com/products/ecoflow-delta-pro-3-portable-power-station',
                                __btn_type: 'href',
                            }}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span>{t('btn1')}</span>
                        </EcoLink>
                        <button className="watch" onClick={handlePlay}>
                            <span>{t('btn')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                    d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM8.79297 6.24219C8.46229 6.00354 8 6.23966 8 6.64746V13.3525C8 13.7603 8.46229 13.9965 8.79297 13.7578L13.4385 10.4053C13.7147 10.2057 13.7147 9.7943 13.4385 9.59473L8.79297 6.24219Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                )}
            </div>
            {/* 左下角 Sign Up Now ! */}
            {/* {pageStatus !== IPageStatus.statusA && (
                <div className="signup">
                    <div className="left-round">{EmailIcon}</div>
                    <div className="signup-text">Sign Up Now !</div>
                </div>
            )} */}

            {isShow && (
                <EfDialogYoutube open={isShow} src={'https://www.youtube.com/embed/pe3bhBdVKbk?si=jrtY-qtSgvpmxqjt'} callback={() => setIsShow(false)} />
            )}
        </div>
    );
};

export default TheComp;
